<template>
    <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button class="text-left" block href="#" v-b-toggle="id" variant="info">
                Q. {{ question }}
            </b-button>
        </b-card-header>
        <b-collapse :id="id" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
                <slot></slot>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
    export default {
        name: "FaqItem",
        props: ['question', 'id'],
    }
</script>

<style scoped>

</style>
